import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. Está diseñado desde cero.'
  }, {
    q: '¿Funciona en departamentos?',
    a: 'Sí, está pensado para espacios pequeños.'
  }, {
    q: '¿Es material digital?',
    a: 'Sí. Acceso inmediato.'
  }, {
    q: '¿Cuándo veo resultados?',
    a: 'Podés empezar en días y ver resultados en semanas.'
  }];
  return <section className="bg-neutral-bg py-16 px-4 sm:px-6 lg:px-8 border-t border-neutral-beige" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-10" data-id="element-17">
          ❓ Preguntas frecuentes
        </h2>
        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl p-6 border border-neutral-beige shadow-sm hover:shadow-md transition-shadow" data-id="element-19">
              <h3 className="text-lg font-black text-[#1A1A1A] mb-2 flex items-start" data-id="element-20">
                <span className="text-garden-medium mr-3" data-id="element-21">Q.</span>
                {faq.q}
              </h3>
              <p className="text-base text-gray-600 font-medium pl-8 leading-relaxed" data-id="element-22">
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}